import React from 'react';
import CityInformation from '../city-information/city-information.component';
import VehicleInformation from '../vehicle-information/vehicle-information.component';

const IteratableInformation = (props) => (
    <div>
        {props.objectType === 'city'
            ? <CityInformation {...props} />
            : <VehicleInformation {...props} />
        }
    </div>
);

export default IteratableInformation;